/**
 * @generated SignedSource<<8fbbe9d950499f1fbd254b1b11b6ea01>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpsertUserDataInput = {
  name: string;
  type: string;
  value: string;
};
export type UpsertUserDataMutation$variables = {
  input: UpsertUserDataInput;
};
export type UpsertUserDataMutation$data = {
  readonly upsertUserData: {
    readonly userData: {
      readonly name: string;
      readonly type: string;
      readonly value: string;
    };
  };
};
export type UpsertUserDataMutation = {
  response: UpsertUserDataMutation$data;
  variables: UpsertUserDataMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpsertUserDataMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpsertUserDataPayload",
        "kind": "LinkedField",
        "name": "upsertUserData",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserData",
            "kind": "LinkedField",
            "name": "userData",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpsertUserDataMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpsertUserDataPayload",
        "kind": "LinkedField",
        "name": "upsertUserData",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserData",
            "kind": "LinkedField",
            "name": "userData",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7620e093cf1dd4805c0fb55ccf30b03e",
    "id": null,
    "metadata": {},
    "name": "UpsertUserDataMutation",
    "operationKind": "mutation",
    "text": "mutation UpsertUserDataMutation(\n  $input: UpsertUserDataInput!\n) {\n  upsertUserData(input: $input) {\n    userData {\n      name\n      type\n      value\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "80b799ba6a2f63051d03e85d2ea84942";

export default node;
